import { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useVersion } from '../versions/url-version';
import { docSlug } from '../versions/versions';

/**
 * Renders the page only if it exists for the version in the URL, otherwise sends the user to the root of that
 * version. Without a predicate it always redirects, which makes it usable as a catch-all route.
 */
export function VersionGuard({
  supports,
  children,
}: {
  supports?: (version: string | undefined) => boolean;
  children?: ReactNode;
}) {
  const version = useVersion();

  if (!supports?.(version)) {
    return <Navigate to={`/api/${docSlug(version)}`} replace />;
  }

  return children;
}
